module.exports = __webpack_public_path__ + "static/media/hl.56544d81.jpg";